import { render, staticRenderFns } from "./extraHeadersComponent.vue?vue&type=template&id=3a20828f&scoped=true"
import script from "./extraHeadersComponent.vue?vue&type=script&lang=js"
export * from "./extraHeadersComponent.vue?vue&type=script&lang=js"
import style0 from "./extraHeadersComponent.vue?vue&type=style&index=0&id=3a20828f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a20828f",
  null
  
)

export default component.exports